import service from "../service";
import { getApiBaseUrl } from "../config";

export default {
    async getCategoryList() {
        const response = await service.get(`${getApiBaseUrl()}category`);
        return response;
    },

    async getSubCategoryList(mainCategory) {
        const response = await service.get(
            `${getApiBaseUrl()}category/sub/${mainCategory}`
        );
        return response;
    },

    async getSubCategorySolutionList(mainCategory) {
        const response = await service.get(
            `${getApiBaseUrl()}category/sub/${mainCategory}/solution`
        );
        return response;
    },

    async getSubCategoryDownloadList(mainCategory) {
        const response = await service.get(
            `${getApiBaseUrl()}category/sub/${mainCategory}/download`
        );
        return response;
    },

    async getCategory(id) {
        const response = await service.get(`${getApiBaseUrl()}category/${id}`);
        return response;
    },

    async addCategory(category) {
        const response = await service.post(
            `${getApiBaseUrl()}category`,
            category
        );
        return response;
    },

    async updateCategory(category) {
        const response = await service.patch(
            `${getApiBaseUrl()}category`,
            category
        );
        return response;
    },

    async deleteCategory(category_id) {
        const response = await service.delete(
            `${getApiBaseUrl()}category/${category_id}`
        );
        return response;
    },
};
